import handler from 'api/handler'

const prefix = '/admin/news'

const methods = {
  update: args => handler({ method: 'put', url: prefix + '/update', args, isFile: true }),
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  getPendingAggregated: args => handler({ method: 'get', url: prefix + '/pendingAggregated', args }),
  approveAggregated: args => handler({ method: 'post', url: prefix + '/approveAggregated', args }),
  rejectAggregated: args => handler({ method: 'post', url: prefix + '/rejectAggregated', args })
}

export default methods
